﻿import { sendApiCall } from "./api";

const webshopUserAuthorizationStorageKey = "uauthdata";

$(window).on("load", function ()
{
    if (shopConfig().api.authorizeFront)
    {
        if (!shopConfig().userLoggedIn)
        {
            if (getUserApiAuthorize() != null)
                sessionStorage.removeItem(webshopUserAuthorizationStorageKey);
        }
        // If logged in but not yet authorized, then authorize user.
        else if (!getUserApiAuthorize())
        {
            $.ajax({
                url: "/Services/Modules/Webshop.asmx/AuthorizeUserForAPI",
                dataType: "json",
                complete: function (data)
                {
                    if (data &&
                        data.status == 200 &&
                        data.responseJSON
                    )
                        setUserApiAuthorize(data.responseJSON);
                }
            });
        }
    }
});

function checkAuthToken()
{
    if (shopConfig().api.authorizeFront && shopConfig().userLoggedIn)
    {
        var authData = getUserApiAuthorize(true);

        if (authData)
        {
            var tokenValidUntil = new Date(authData.accessTokenValidUntil);
            var currentDateTime = new Date();
            // Add some leeway to allow refresh right before expire.
            currentDateTime.setSeconds(currentDateTime.getSeconds() + 10);

            if (tokenValidUntil <= currentDateTime)
            {
                var refreshValidUntil = new Date(authData.refreshTokenValidUntilUtc);

                // Use refresh token to generate new access token.
                if (refreshValidUntil > currentDateTime)
                {
                    var callback = function (responseData, responseState)
                    {
                        if (responseState === "success")
                            setUserApiAuthorize(responseData);
                    }

                    var authDto = {
                        token: authData.refreshToken
                    };

                    sendApiCall({ endpoint: "/Webshop_user/get-accesstoken", rawUrl: location.pathname, callback: callback, customDto: authDto, beforeSend: getAuthRequestHeader(true) });
                }
                else
                    removeUserApiAuthorize();
            }
        }
    }
}

export const getAuthRequestHeader = (skipAuthTokenCheck: boolean) =>
{
    if (shopConfig().api.authorizeFront)
    {
        var authData = getUserApiAuthorize(skipAuthTokenCheck);

        if (authData)
        {
            return function (xhr)
            {
                xhr.setRequestHeader("Authorization", `Bearer ${authData.accessToken}`);
            };
        }
    }

    return function () { };
}

export const authorizeUserForApi = (email, password, callbackFunction) =>
{
    if (shopConfig().api.authorizeFront)
    {
        var callback = function (responseData, responseState)
        {
            if (responseState === "success")
            {
                setUserApiAuthorize(responseData);
                callbackFunction();
            }
        }

        var authDto = {
            email: email,
            password: password
        };

        sendApiCall({ endpoint: "/Webshop_user/authorize", rawUrl: location.pathname, callback: callback, customDto: authDto, beforeSend: getAuthRequestHeader(true) });
    }
    else
        callbackFunction();
}

export const setUserApiAuthorize = (authData) =>
{
    if (shopConfig().api.authorizeFront && authData)
        sessionStorage.setItem(webshopUserAuthorizationStorageKey, JSON.stringify(authData));
}

export const getUserApiAuthorize = (skipAuthTokenCheck?: boolean) =>
{
    if (shopConfig().api.authorizeFront)
    {
        if (!skipAuthTokenCheck)
        {
            // Check if still valid.
            checkAuthToken();
        }

        if (shopConfig().userLoggedIn)
        {
            var userAuthInfo = sessionStorage.getItem(webshopUserAuthorizationStorageKey);

            if (typeof (userAuthInfo) !== typeof (undefined) &&
                userAuthInfo != null
            )
                return JSON.parse(userAuthInfo);
        }
        else
            removeUserApiAuthorize();
    }

    return null;
}

function removeUserApiAuthorize()
{
    sessionStorage.removeItem(webshopUserAuthorizationStorageKey);
}
